/* Copyright IBM Corp. 2017 */

/**
 * Escapes a term according to lucence syntax
 *
 * @param aTerm
 */
function _escapeTerm(aTerm: string): string {
    return aTerm.replace(/[\s\+\-\&\|\!\(\)\{\}\[\]\^\"\~\*\?\:\\]/g, '\\$&');
}

function _escapeKeyValue(aKey: string, aTerm: string): string {
    return `${aKey}:("${_escapeTerm(aTerm)}")`;
}

export {
    _escapeTerm as luceneEscapeTerm,
    _escapeKeyValue as luceneEscapeKeyValue
};
